//packages
import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { v4 } from 'uuid'

//custom components
import Button from 'components/Button'
import { ModalCloseIcon } from 'components/Icons'
import UploadResumeV2 from 'components/Upload/UploadResumeV2'
import UploadCoverLetterVideo from 'components/Upload/UploadCoverLetterVideo'
import AuthService from 'app/services/auth.service'

//redux
import { createApplication, resetAllStatus } from 'app/store/applicantsSlice'
import { getUser, updateUser } from 'app/store/profileSlice'
import Tooltip from 'components/Tooltip'

export default function SubmitApplicationModal({
  isOpen,
  closeModal,
  submittedSuccess,
}) {
  const dispatch = useDispatch()
  const user = useSelector(getUser)
  const selectedJob = useSelector((state) => state.job.selectedJob)
  const loading = useSelector((state) => state.applicants.createLoading)

  const [message, setMessage] = useState('')
  const [inCludeResume, setInCludeResume] = useState(
    user?.resume ? true : false
  )
  const [progress, setProgress] = useState()
  const [maxSizeError, setMaxSizeError] = useState('')
  const [isVideoUploading, setIsVideoUploading] = useState(false)

  const [fileName, setFileName] = useState(user != null ? user.resume : '')
  const [coverLetterVideo, setCoverLetterVideo] = useState('')

  function handleUploadChange(e) {
    const file = e.target.files[0]
    if (!file) {
      return
    }
    const reader = new FileReader()

    reader.readAsBinaryString(file)

    reader.onload = () => {
      // setFileUrl(`data:${file.type};base64,${btoa(reader.result)}`);
      const array = file.name.split('.')
      const extension = array[array.length - 1]
      const param = {
        fileContent: btoa(reader.result),
        fileName: `${v4()}.${extension}`,
      }
      AuthService.uploadFileToS3(param)
        .then((res) => {
          // formik.setFieldValue('resume', res.data.url)
          setFileName(res.data.url)
          setInCludeResume(true)
        })
        .catch((err) => {
          console.log(err)
        })
    }

    reader.onerror = () => {
      console.log('error on load image')
    }
  }

  async function handleVideoUploadChange(e) {
    const file = e.target.files[0]
    console.log(file)

    const MAX_FILE_SIZE = 500 * 1024 * 1024
    if (file && file.size > MAX_FILE_SIZE) {
      // File size exceeds the limit, show an error message or handle it accordingly
      setMaxSizeError(true)
      return
    }

    setProgress(0)
    setMaxSizeError(false)
    setIsVideoUploading(true)
    const totalBytes = file.size
    console.log(totalBytes)
    let uploadedBytes = 0
    let totalBytes2 = file.size

    if (!file) {
      return
    }

    try {
      const S3_BUCKET = process.env.REACT_APP_AWS_BUCKET_NAME
      const REGION = process.env.REACT_APP_AWS_REGION
      const PART_SIZE = 5 * 1024 * 1024 // 5 MB part size

      AWS.config.update({
        accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
        secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
      })

      const s3 = new AWS.S3({
        params: { Bucket: S3_BUCKET },
        region: REGION,
      })

      const params = {
        Bucket: S3_BUCKET,
        Key: file.name,
      }

      const uploadIdResp = await s3.createMultipartUpload(params).promise()
      const uploadId = uploadIdResp.UploadId
      const numParts = Math.ceil(file.size / PART_SIZE)

      const uploadPromises = Array.from({ length: numParts }, (_, index) => {
        const start = index * PART_SIZE
        const end = Math.min(start + PART_SIZE, file.size)
        const partNumber = index + 1
        const part = file.slice(start, end)

        const partParams = {
          Bucket: S3_BUCKET,
          Key: file.name,
          UploadId: uploadId,
          PartNumber: partNumber,
          Body: part,
        }

        return s3
          .uploadPart(partParams)
          .on('httpUploadProgress', (progress) => {
            if (numParts <= 1) {
              const currentUploadedBytes = progress.loaded + start
              const percentUploaded = Math.round(
                (currentUploadedBytes / totalBytes) * 100
              )
              console.log(`Overall upload progress: ${percentUploaded}%`)
              console.log(currentUploadedBytes, totalBytes)
              setProgress(percentUploaded)
            } else {
              totalBytes2 += progress.total
              uploadedBytes += progress.loaded
              const percentUploaded = Math.round(
                (uploadedBytes / totalBytes2) * 200
              )
              setProgress(percentUploaded)
              console.log(`Overall upload progress: `, percentUploaded)

              console.log(progress.total)
              console.log(progress)
            }
            console.log(numParts)
          })
          .promise()
          .then((data) => {
            console.log(`Uploaded Part #${partNumber}: ETag - ${data.ETag}`)
            return {
              ETag: data.ETag,
              PartNumber: partNumber,
            }
          })
      })

      const uploadedParts = await Promise.all(uploadPromises)
      const completedParams = {
        Bucket: S3_BUCKET,
        Key: file.name,
        UploadId: uploadId,
        MultipartUpload: {
          Parts: uploadedParts,
        },
      }

      await s3.completeMultipartUpload(completedParams).promise()

      const objectUrl = `https://${S3_BUCKET}.s3.${REGION}.amazonaws.com/${file.name}`
      setCoverLetterVideo(objectUrl)
      setIsVideoUploading(false)
    } catch (err) {
      console.error('Error uploading video:', err)
      setIsVideoUploading(false)
    }
  }

  const resume = user != null ? user.resume : ''

  const handleSubmit = async () => {
    // if editted the resume (v1 doesnt allow employee to change resume here)
    if (fileName !== resume) {
      let data = {
        resume: fileName,
      }
      const paramsResume = {
        userId: user.id,
        data,
      }
      const resultActionResume = await dispatch(updateUser(paramsResume))
      if (updateUser.fulfilled.match(resultActionResume)) {
        const params = {
          userId: user.id,
          jobId: selectedJob.id,
        }

        const resultAction = await dispatch(createApplication(params))
        if (createApplication.fulfilled.match(resultAction)) {
          toast.success('Submitted Successfully')
        } else {
          if (resultAction.payload) {
            toast.error('Submit failed: ' + resultAction.payload.errorMessage)
          } else {
            toast.error('Submit failed' + resultAction.error.message)
          }
        }
        submittedSuccess()
      } else {
        if (resultActionResume.payload) {
          toast.error(
            'Update Resume failed: ' + resultActionResume.payload.errorMessage
          )
        } else {
          toast.error('Update Resume failed' + resultActionResume.error.message)
        }
      }
    } else {
      const params = {
        userId: user.id,
        jobId: selectedJob.id,
        coverLetterVideo: coverLetterVideo,
      }

      const resultAction = await dispatch(createApplication(params))
      if (createApplication.fulfilled.match(resultAction)) {
        toast.success('Submitted Successfully')
      } else {
        if (resultAction.payload) {
          toast.error('Submit failed: ' + resultAction.payload.errorMessage)
        } else {
          toast.error('Submit failed' + resultAction.error.message)
        }
      }
      submittedSuccess()
    }
  }

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => {}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto bg-[ #1B1D21] bg-opacity-70">
          <div className="flex min-h-full items-center justify-center p-0 text-center relative">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full rounded-2xl max-w-[694px] transform overflow-hidden text-left align-middle shadow-xl transition-all">
                <div className="bg-white py-[20px] px-[25px] md:p-8 max-w-[694px] h-[440px] relative">
                  <div
                    className="absolute right-0 top-[10px]"
                    onClick={closeModal}
                  >
                    <ModalCloseIcon className="text-black-100 hover:text-green-100 cursor-pointer w-[50px] md:w-auto h-[50px] md:h-auto" />
                  </div>
                  <h5 className="text-black-100 md:leading-[36px] text-[18px] md:text-2xl font-semibold text-center mb-[35px] mt-[20px]">
                    Submit Application
                  </h5>
                  {/* <p className="text-gray-100 leading-[18px] md:leading-4 text-[13px] md:text-sm font-medium mt-[16px] md:mt-4">
                    Please give a brief description of why you would be a good
                    fit for this job, attach your resume and any reference
                    materials you would like.
                  </p>
                  <div className="mt-[20px] md:mt-10">
                    <Checkbox
                      variant="primary"
                      label="Attach Resume"
                      labelClassName="text-black-100 leading-4 text-sm font-medium"
                      value={inCludeResume}
                      onChange={(e) => setInCludeResume(e.target.checked)}
                    />
                  </div> */}
                  {/* <div className="mt-[20px] md:mt-7">
                    <TextArea
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      placeholder="Add Message.."
                    />
                  </div> */}
                  <div className="mt-[35px] md:mt-[25px] h-[79px]">
                    <p className="text-[12px] leading-[16px] md:leading-4 text-[#B2B3BD] font-medium mb-3">
                      Resume <span className="text-red-200">*</span>
                    </p>
                    <UploadResumeV2
                      btnName="Change"
                      crossIconColor="text-red-200"
                      showInfoDiv={false}
                      handleUploadChange={handleUploadChange}
                      fileName={fileName}
                      cancelUpload={() => {
                        setFileName('')
                        setInCludeResume(false)
                      }}
                    />
                  </div>
                  {(selectedJob?.coverLetterVideoRequirement === 'mandatory' ||
                    selectedJob?.coverLetterVideoRequirement ===
                      'encouraged') && (
                    <div className="mt-[25px] md:mt-[25px] h-[79px]">
                      <div className="flex">
                        <p className="flex text-[12px] leading-[16px] md:leading-4 text-[#B2B3BD] font-medium mb-3">
                          Cover Letter Video{' '}
                          <span className="text-red-200 ml-1">*</span>
                        </p>
                        <Tooltip
                          text={
                            <div className="m-6">
                              <h6 className="text-[#1E3E85] font-poppins text-base not-italic font-semibold">
                                Cover letter video
                              </h6>
                              <p className="text-[rgba(17, 20, 45, 0.80)] font-inter not-italic text-sm font-medium leading-[22px]">
                                This position requires a cover letter video.
                              </p>

                              <h6 className="text-[rgba(17, 20, 45, 0.80)] font-inter text-sm not-italic font-bold leading-[22px] mt-2">
                                Instructions:
                              </h6>

                              <ul className="ml-6 list-disc">
                                <li>
                                  {selectedJob?.coverLetterVideoInstructions}
                                </li>
                              </ul>
                            </div>
                          }
                        >
                          <div className="cursor-pointer ml-1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                            >
                              <g clip-path="url(#clip0_8976_17963)">
                                <path
                                  d="M14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7Z"
                                  fill="#1E3E85"
                                />
                                <path
                                  d="M4.58398 5.36246C4.58398 5.05654 4.6822 4.74658 4.87864 4.43258C5.07508 4.11858 5.3617 3.85853 5.73849 3.65241C6.11533 3.44642 6.5549 3.34337 7.05723 3.34326C7.52409 3.34326 7.9363 3.42941 8.29385 3.60171C8.6514 3.77402 8.92757 4.00831 9.12236 4.30459C9.31396 4.59026 9.41574 4.9267 9.41461 5.27067C9.41461 5.5444 9.35901 5.78432 9.24782 5.99044C9.14357 6.18738 9.01002 6.36735 8.85172 6.52419C8.69877 6.67398 8.42425 6.92598 8.02815 7.28019C7.9356 7.36301 7.84771 7.4509 7.76488 7.54345C7.70767 7.6066 7.65822 7.67637 7.61758 7.75127C7.58637 7.81139 7.56129 7.87451 7.54272 7.93966C7.52496 8.00248 7.49838 8.11277 7.46298 8.27052C7.40177 8.60548 7.21017 8.77294 6.88819 8.77288C6.81036 8.77489 6.73291 8.7614 6.66035 8.73321C6.58778 8.70501 6.52154 8.66268 6.46548 8.60866C6.35113 8.49928 6.29397 8.33666 6.29401 8.12079C6.29401 7.85029 6.33586 7.61604 6.41957 7.41805C6.49943 7.22598 6.61223 7.04933 6.75289 6.89609C6.93052 6.7088 7.11754 6.53065 7.31322 6.36231C7.5193 6.18201 7.66826 6.04595 7.7601 5.95413C7.85127 5.86316 7.92929 5.75992 7.99192 5.64738C8.05457 5.53523 8.08702 5.40873 8.08609 5.28027C8.08799 5.15728 8.06329 5.03534 8.01369 4.92279C7.96409 4.81024 7.89075 4.70973 7.79871 4.62814C7.60705 4.4511 7.35989 4.36255 7.05723 4.36247C6.70296 4.36247 6.44212 4.4518 6.2747 4.63044C6.10729 4.80909 5.96557 5.07234 5.84956 5.42021C5.74006 5.78434 5.53236 5.9664 5.22645 5.9664C5.14127 5.96811 5.05668 5.95202 4.97807 5.91916C4.89947 5.88631 4.82858 5.83741 4.76995 5.7756C4.64597 5.64834 4.58398 5.51063 4.58398 5.36246ZM6.94132 10.6567C6.75206 10.6594 6.56861 10.5914 6.42687 10.4659C6.28027 10.3388 6.207 10.1608 6.20705 9.93215C6.20501 9.83673 6.22284 9.74192 6.25943 9.65377C6.29602 9.56561 6.35056 9.48604 6.41957 9.42011C6.48812 9.35219 6.56964 9.29879 6.65929 9.26309C6.74893 9.22738 6.84485 9.21011 6.94132 9.2123C7.03622 9.21092 7.13043 9.2286 7.21838 9.2643C7.30633 9.29999 7.38622 9.35296 7.45332 9.42009C7.52043 9.48721 7.57338 9.56711 7.60905 9.65507C7.64472 9.74303 7.66238 9.83725 7.66098 9.93215C7.66098 10.1576 7.58851 10.3347 7.44357 10.4635C7.30668 10.5892 7.12717 10.6583 6.94132 10.6567Z"
                                  fill="white"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_8976_17963">
                                  <rect width="14" height="14" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                        </Tooltip>
                      </div>
                      <UploadCoverLetterVideo
                        handleVideoUploadChange={handleVideoUploadChange}
                        isVideoUploading={isVideoUploading}
                        progress={progress}
                        fileName={coverLetterVideo}
                        cancelUpload={() => {
                          setCoverLetterVideo('')
                        }}
                      />
                    </div>
                  )}

                  <div className="mt-[30px] md:mt-[30px] flex gap-5 justify-center items-center">
                    <Button
                      onClick={handleSubmit}
                      variant="secondary"
                      className="w-[150px] h-[56px] flex justify-center items-center"
                      disabled={
                        loading === 'pending' ||
                        isVideoUploading ||
                        (selectedJob?.coverLetterVideoRequirement ===
                          'mandatory' &&
                          coverLetterVideo === '')
                      }
                    >
                      Submit
                    </Button>
                    {/* <Button
                      onClick={closeModal}
                      variant="error"
                      className="w-40 mb-5"
                      disabled={loading === 'pending'}
                    >
                      No
                    </Button> */}
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}
